import * as React from 'react';
import { IGalleryTab } from '../../../types/gallery';
import * as styles from './InfoTabs.css';

interface IInfoTabsProps {
  tabs: IGalleryTab[];
  offsetBottom: number;
  onTabClick?(tab: IGalleryTab): void;
}

export const InfoTabs: React.FC<IInfoTabsProps> = ({ offsetBottom, tabs, onTabClick }) => {
  const handleTabClick = React.useCallback(
    (tab: IGalleryTab) => {
      if (onTabClick) {
        onTabClick(tab);
      }
    },
    [onTabClick],
  );

  return (
    <div className={styles['tabs']} style={{ bottom: offsetBottom }}>
      {tabs.map((tab, index) => (
        <div className={styles['tab']} key={index} onClick={() => handleTabClick(tab)}>
          <div>{tab.icon}</div>
          <div className={styles['title']}>{tab.title}</div>
        </div>
      ))}
    </div>
  );
};
